module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_UPSA.ee4eb288.png";